import React from 'react'

import ItemWrapper from './currencyList.css'
import store from '../../../../../../../../redux'
import IconCurrency from '../../../../../../../elements/currencyMobile'
import CurrencyName from '../../../../../../../MobileExchenger/elements/currency'
import Currency from '../../../../../../../MobileExchenger/elements/CurrencyName'

const CurrencyListItem = (props) => {

    const { item, index, side, handler, currencySelectHandler, hideAnimation } = props

    const state = store.getState().firstScreen

    const checked = state[side.toLowerCase() + 'Currency'] === item

    return (
        <ItemWrapper
            checked={checked}
        >
            <label htmlFor={JSON.stringify(item)} className='label-item'>
                <div className='wrapper'>
                    <div className='icon-wrapper'>
                        <IconCurrency 
                            currencyCode={item}
                            checked={checked}
                        />
                    </div>
                    <div className='currency-name'>
                        <div className='currency-wrapper'>
                            <div className='currency-code'>
                                {CurrencyName[item]}
                            </div>
                            <div className='item-wrapper'>
                                {Currency[item]}
                            </div>
                        </div>
                    </div>
                </div>
            </label>
            <input
                type='radio'
                value={JSON.stringify(item)}
                key={index}
                id={JSON.stringify(item)}
                readOnly
                checked={JSON.stringify(state[side.toLowerCase() + 'Currency']) === JSON.stringify(item)}
                onClick={event => handler ? handler(JSON.parse(event.target.value), side, currencySelectHandler, hideAnimation) : null}
            />
        </ItemWrapper>
    )

}

export default CurrencyListItem